import { IOrganization } from '@/fsd/entities/organization/model/types/types';
import { IProduct } from '@/fsd/entities/product';
import { IWarehouse } from '@/fsd/entities/warehouse';

interface IParams {
  organizations?: IOrganization[];
  products?: IProduct[];
  warehouses?: IWarehouse[];
}

export const getRemainsListFilterFieldsOptions = ({
  organizations,
  products,
  warehouses,
}: IParams) => {
  const organizationsOptions =
    organizations?.map((organization) => ({
      label: organization.name,
      value: organization.id,
    })) || [];

  const warehousesOptions =
    warehouses?.map((warehouse) => ({
      label: warehouse.name,
      value: warehouse.id,
    })) || [];

  const productOptions =
    products?.map((product) => ({
      label: product.name || '',
      value: product.id,
    })) || [];

  const categoriesSet = new Set<string>();
  products?.forEach((product) => {
    if (product.category) {
      categoriesSet.add(product.category);
    }
  });
  const categoriesOptions = Array.from(categoriesSet).map((category) => ({
    label: category,
    value: category,
  }));

  return {
    organizationsOptions,
    productOptions,
    warehousesOptions,
    categoriesOptions,
  };
};
